import BaseBusinessAPI from '../portal/baseBusinessAPI'

class AdditionServiceAPI extends BaseBusinessAPI {
  controllerName = 'EnrollmentAdditionServices';
}

export default new AdditionServiceAPI()
